if (!customElements.get('product-fomo')) {
  customElements.define(
    'product-fomo',
    class ProductFomo extends HTMLElement {
      connectedCallback() {
        this.messages = [...this.querySelectorAll('[data-fomo-message]')];
        this.activeIndex = 0;
        this.interval = Math.max(Number(this.dataset.rotationInterval) || 3000, 3000);

        if (this.messages.length < 2) return;

        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        this.startRotation();
      }

      disconnectedCallback() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        this.stopRotation();
      }

      handleVisibilityChange = () => {
        if (document.hidden) {
          this.stopRotation();
        } else {
          this.startRotation();
        }
      };

      startRotation() {
        this.stopRotation();
        this.rotationTimer = window.setInterval(() => this.showNextMessage(), this.interval);
      }

      stopRotation() {
        window.clearInterval(this.rotationTimer);
      }

      showNextMessage() {
        this.messages[this.activeIndex].setAttribute('aria-hidden', 'true');
        this.activeIndex = (this.activeIndex + 1) % this.messages.length;
        this.messages[this.activeIndex].setAttribute('aria-hidden', 'false');
      }
    }
  );
}
